(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["HeaderMenuIcon"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__headerCartKeysInstalled) return;
    window.__headerCartKeysInstalled = true;

    /* Anchor tanpa href tidak lagi diaktifkan Enter oleh browser, dan
       role="button" menjanjikan Space juga bekerja. Keduanya diteruskan ke
       click() supaya hanya ada SATU jalur pembuka drawer — handler milik
       app.bundle.js — bukan dua jalur yang bisa berbeda perilaku. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var el = e.target && e.target.closest && e.target.closest('a.button-cart[role="button"]');
      if (!el || el.hasAttribute('href')) return;
      e.preventDefault();
      el.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-avatar"] && !Shopify.designMode) return;
  try {
    /* Sinkron foto Facebook → metafield pelanggan, tanpa klik.
     Hanya jalan untuk pelanggan login yang belum punya foto, sekali per
     RETRY_AFTER per perangkat, saat browser senggang. Gagal = diam saja. */
  (function () {
    var APP_ID = '3328781347322130';
    var GRAPH_VERSION = 'v26.0';
    var ENDPOINT = '/apps/treelogy/avatar/facebook';
    var RETRY_AFTER = 14 * 864e5;
    var ERROR_RETRY_AFTER = 864e5;
    var SDK_TIMEOUT = 8000;

    if (window.__tlAvatarSync) return;
    window.__tlAvatarSync = true;

    function targets() {
      return document.querySelectorAll('[data-customer-avatar][data-avatar-state="missing"]');
    }

    var first = targets()[0];
    if (!first) return;
    var key = 'tl_avatar_fb:' + first.getAttribute('data-customer-id');

    function readState() {
      try {
        return JSON.parse(localStorage.getItem(key) || 'null');
      } catch (e) {
        return null;
      }
    }

    function writeState(result, retryAfter) {
      try {
        localStorage.setItem(key, JSON.stringify({ r: result, next: Date.now() + retryAfter }));
      } catch (e) {}
    }

    var last = readState();
    if (last && last.next > Date.now()) return;

    function consentDenied() {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!(p && typeof p.preferencesProcessingAllowed === 'function' && !p.preferencesProcessingAllowed());
    }

    function paint(url) {
      var els = targets();
      for (var i = 0; i < els.length; i++) {
        (function (el) {
          var img = new Image();
          img.className = 'customer-avatar__img';
          img.alt = '';
          img.decoding = 'async';
          img.referrerPolicy = 'no-referrer';
          img.onload = function () {
            el.replaceChildren(img);
            el.setAttribute('data-avatar-state', 'ready');
          };
          img.src = url;
        })(els[i]);
      }
    }

    function loadSdk() {
      return new Promise(function (resolve, reject) {
        var timer = setTimeout(function () {
          reject(new Error('timeout'));
        }, SDK_TIMEOUT);
        window.fbAsyncInit = function () {
          clearTimeout(timer);
          resolve(window.FB);
        };
        var s = document.createElement('script');
        s.src = 'https://connect.facebook.net/en_US/sdk.js';
        s.async = true;
        s.crossOrigin = 'anonymous';
        s.onerror = function () {
          clearTimeout(timer);
          reject(new Error('blocked'));
        };
        document.head.appendChild(s);
      });
    }

    function loginStatus(FB) {
      return new Promise(function (resolve) {
        var timer = setTimeout(function () {
          resolve(null);
        }, SDK_TIMEOUT);
        FB.getLoginStatus(function (res) {
          clearTimeout(timer);
          resolve(res);
        });
      });
    }

    function run() {
      if (consentDenied()) return;
      /* SDK Facebook milik pihak lain sudah terpasang: jangan di-init ulang
         dengan app id kita, bisa merusak integrasi mereka. */
      if (window.FB) return writeState('foreign_sdk', RETRY_AFTER);

      loadSdk()
        .then(function (FB) {
          FB.init({ appId: APP_ID, version: GRAPH_VERSION, cookie: false, xfbml: false, status: false });
          return loginStatus(FB);
        })
        .then(function (res) {
          if (!res || res.status !== 'connected' || !res.authResponse) {
            writeState(res ? res.status : 'no_status', RETRY_AFTER);
            return;
          }
          return fetch(ENDPOINT, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ accessToken: res.authResponse.accessToken }),
          })
            .then(function (r) {
              return r.ok ? r.json() : { status: 'http_' + r.status };
            })
            .then(function (out) {
              if (out && out.url && (out.status === 'synced' || out.status === 'unchanged')) paint(out.url);
              var failed = !out || out.status === 'error' || /^http_/.test(out.status);
              writeState(out ? out.status : 'empty', failed ? ERROR_RETRY_AFTER : RETRY_AFTER);
            });
        })
        .catch(function (err) {
          writeState(String((err && err.message) || 'error'), ERROR_RETRY_AFTER);
        });
    }

    function start() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 4000 });
      } else {
        setTimeout(run, 2500);
      }
    }

    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["io-base"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ioRevealReady) return;
    window.__ioRevealReady = true;

    function show(el) {
      el.classList.add('io-reveal--in');
    }

    function init() {
      var targets = document.querySelectorAll('.io-reveal:not(.io-reveal--in)');
      if (!targets.length) return;

      if (
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        targets.forEach(show);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              show(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lp-only-guard"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORAGE_KEY = 'lp_source';

    function post(url, payload) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (!res.ok) throw new Error('cart request failed: ' + res.status);
        return res.json();
      });
    }

    function repaint(cart) {
      // Tema menyediakan pembaruan mini-cart-nya sendiri; pakai itu supaya
      // jumlah item dan total ikut berubah tanpa memuat ulang halaman.
      if (typeof window.refreshCartUI === 'function') {
        try {
          window.refreshCartUI(cart);
          return true;
        } catch (e) {
          /* jatuh ke muat ulang di bawah */
        }
      }
      return false;
    }

    function run(root) {
      if (root.dataset.lpGuardDone === '1') return;
      root.dataset.lpGuardDone = '1';

      var keys = (root.getAttribute('data-keys') || '').split('||').filter(Boolean);
      if (!keys.length) return;

      var inFunnel = root.getAttribute('data-in-funnel') === 'true';

      if (inFunnel) {
        // Masih di dalam alur landing page. Pastikan asal-usulnya tercatat pada
        // keranjang supaya ikut terbawa ke pesanan.
        if ((root.getAttribute('data-source') || '').trim()) return;

        var marker = '';
        try {
          marker = sessionStorage.getItem(STORAGE_KEY) || '';
        } catch (e) {
          marker = '';
        }

        post('/cart/update.js', {
          attributes: { lp_source: marker || root.getAttribute('data-landing-handle') }
        }).catch(function () {});
        return;
      }

      // Di luar alur: keluarkan dari keranjang, termasuk di sisi server.
      var updates = {};
      keys.forEach(function (key) {
        updates[key] = 0;
      });

      post('/cart/update.js', { updates: updates })
        .then(function (cart) {
          if (!repaint(cart)) window.location.reload();
        })
        .catch(function () {});
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-lp-guard]').forEach(run);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
